<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-head">
            <slot name="header">
              default header
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              default body
            </slot>
          </div>
          <div class="modal-footer">
            <slot name="footer">
              <button class="button bbutton" @click="$emit('close')">
                <slot name="button">
                  close
                </slot>
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import './dashboard-modal.scss';
  
export default {
  name: "acclaro-modal.vue",
  data: function () {
    return {
      showModal: false
    };
  },
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  min-width: 50%;
  max-width: 50%;
  height: fit-content;
  margin: auto;
  background-color: #FFFFFF;
  transition: all 0.3s ease;
  font-family: 'Open Sans', HelveticaNeue, Helvetica-Neue, Helvetica, Arial, sans-serif !important;
  color: #333;
  border-radius: 10px;
  box-shadow: 0 4px 8px 0 rgb(0 0 0 / 20%);
  box-sizing: border-box;
}

.modal-head {
  font-size: 12px;
}

.modal-body {
  max-height: 600px;
  cursor: default !important;
}

.modal-head h1 {
  font-size: 20px;
  font-weight: 400;
  line-height: 1;
  margin-bottom: 18px;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

</style>
